// Site-wide constants for Elevara Systems

export const BOOK_A_CALL_URL = "https://grow.theelevara.com";
export const LOGIN_URL = "https://app.theelevara.com";

export const CONTACT = {
    email: "contact@theelevara.com",
    phone: "941-807-5580",
    phoneHref: "tel:+19418075580",
    instagram: "https://www.instagram.com/official.elevara/",
    instagramHandle: "@official.elevara",
    gmb: "https://www.google.com/maps/place/Elevara+Media/@29.702168,-84.2237664,6z/data=!4m16!1m9!3m8!1s0x2a9d102b5b05b797:0x43f83d0e4f33c751!2sElevara+Media!8m2!3d29.702168!4d-84.2237664!9m1!1b1!16s%2Fg%2F11njzl2g8n!3m5!1s0x2a9d102b5b05b797:0x43f83d0e4f33c751!8m2!3d29.702168!4d-84.2237664!16s%2Fg%2F11njzl2g8n?entry=ttu&g_ep=EgoyMDI2MDYwMy4xIKXMDSoASAFQAw%3D%3D",
};

export const SITE = {
    name: "Elevara Systems",
    domain: "theelevara.com",
    url: "https://theelevara.com",
    tagline: "Marketing systems for home service businesses.",
    description:
        "Elevara Systems builds the marketing systems home service businesses actually need — website, reviews, missed-call text-back, campaigns, local SEO, unified inbox, and business phone. One plan. No bull*.",
};

export const ABOUT_DROPDOWN = [
    {
        label: "Our Story",
        description: "Why Elevara Systems exists",
        to: "/about#story",
    },
    {
        label: "How We Operate",
        description: "Four rules we don't break",
        to: "/about#values",
    },
    {
        label: "Our Mission",
        description: "What we're building toward",
        to: "/about#mission",
    },
    {
        label: "The Founder",
        description: "Meet the person behind it",
        to: "/about#founder",
    },
];
